'use strict';

angular.module('portal.i18n', [
    'ngCookies',
    'gettext',
]);
